<template>
    <div>
      <el-button type="primary" @click="openDialog">新增合作伙伴</el-button>
  
      <!-- 合作伙伴表格 -->
      <el-table :data="list" style="width: 100%; margin-top: 20px;">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="name" label="名称" width="120" />
        <el-table-column prop="logo" label="Logo" width="220" align="center">
          <template slot-scope="scope">
            <el-image :src="getFullImageUrl(scope.row.logo)" fit="cover" style="width: 120px; height: 120px;" />
          </template>
        </el-table-column>
        <el-table-column prop="timeCreated" label="创建时间" width="300" align="center" />
        <el-table-column prop="timeUpdated" label="更新时间" width="300" align="center" />
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button size="small" @click="edit(scope.row)">编辑</el-button>
            <el-button size="small" type="danger" @click="remove(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
  
      <!-- 分页 -->
      <el-pagination
        style="margin-top: 20px; text-align: right;"
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page.sync="page"
        @current-change="loadPartners"
      />
  
      <!-- 新增/编辑对话框 -->
      <el-dialog :visible.sync="showDialog" title="合作伙伴管理" width="600px">
        <el-form :model="form" label-width="80px">
          <el-form-item label="名称">
            <el-input v-model="form.name" />
          </el-form-item>
          <el-form-item label="Logo">
            <input type="file" ref="fileInput" @change="onFileChange" />
            <div v-if="form.logoPreview" style="margin-top: 10px;">
              <el-image :src="form.logoPreview" style="width: 120px; height: 120px;" fit="cover" />
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="save">保存</el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import { Message } from "element-ui";
  import { getPartnersList, addPartner, updatePartner, deletePartner } from "@/api/partners.js";
  
  export default {
    name: "Partners",
    data() {
      return {
        list: [],
        total: 0,
        page: 1,
        pageSize: 5,
        showDialog: false,
        form: {
          id: null,
          name: "",
          logoFile: null,      // 上传文件对象
          logoPreview: null    // 图片预览
        }
      };
    },
    created() {
      this.loadPartners();
    },
    methods: {
      async loadPartners() {
        try {
          const res = await getPartnersList({ page: this.page, pageSize: this.pageSize });
          if (res.status === 200) {
            this.list = res.data.data.list || [];
            this.total = res.data.data.total || 0;
          } else {
            Message.error(res.msg || "获取合作伙伴列表失败");
          }
        } catch (err) {
          Message.error("请求异常");
        }
      },
  
      openDialog() {
        this.resetForm();
        this.showDialog = true;
      },
  
      edit(row) {
        this.form = {
          id: row.id,
          name: row.name,
          logoFile: null,
          logoPreview: this.getFullImageUrl(row.logo)
        };
        this.showDialog = true;
      },
  
      closeDialog() {
        this.resetForm();
        this.showDialog = false;
      },
  
      onFileChange(e) {
        const file = e.target.files[0];
        if (file) {
          this.form.logoFile = file;
          this.form.logoPreview = URL.createObjectURL(file);
        }
      },
  
      async save() {
        try {
          const formData = new FormData();
          formData.append("name", this.form.name);
          if (this.form.logoFile) {
            formData.append("logo", this.form.logoFile);
          }
  
          let res;
          if (this.form.id) {
            formData.append("id", this.form.id);
            res = await updatePartner(formData);
          } else {
            res = await addPartner(formData);
          }
  
          if (res.status === 200) {
            Message.success("保存成功");
            this.showDialog = false;
            this.loadPartners();
          } else {
            Message.error(res.msg || "保存失败");
          }
        } catch (err) {
          Message.error("请求异常");
        }
      },
  
      async remove(id) {
        try {
          const formData = new FormData();
          formData.append("id", id);
          const res = await deletePartner(formData);
          if (res.status === 200) {
            Message.success("删除成功");
            this.loadPartners();
          } else {
            Message.error(res.msg || "删除失败");
          }
        } catch (err) {
          Message.error("请求异常");
        }
      },
  
      getFullImageUrl(path) {
        return path ? (path.startsWith("http") ? path : this.$serverUrl + path) : "";
      },
  
      resetForm() {
        this.form = {
          id: null,
          name: "",
          logoFile: null,
          logoPreview: null
        };
        // 清空文件选择框
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = "";
        }
      }
    }
  };
  </script>
  